<template>
  <div class="top10-opportunities-newsletter" v-if="can_subscribe">

    <div class="top10-opportunities-newsletter__body">
      <input v-if="!me" :class="['email-subscribe__input', {'error':errors.length}]" placeholder="Enter your email" @keyup.enter="doSubscribe" v-model.trim="email" required/>

      <button class="email-subscribe__button" @click="doSubscribe" aria-label="Newsletter Subscribe">
        <block-spinner :active="isLoading" size="5" color="text-white" class="absolute"></block-spinner>
        <span :class="[{'opacity-0':isLoading}]">Sign up</span>
      </button>
    </div>

    <p v-if="errors.length" class="error">{{ errors[0] }}</p>

    <div class="top10-opportunities-newsletter__footer">
      <img class="avatars" src="/images/home/avatars.png" alt="Avatars">

      <img class="arrow" src="/images/home/arrow.svg" alt="Arrow">
      
      <div class="text">
        <p>Join 780k professionals wanting to do something different.</p>
      </div>
    </div>

  </div> 
</template>

<script>
import NewsletterMixins from '@/mixins/NewsletterMixins';

export default {
	mixins: [NewsletterMixins],

  data() {
		return {
			newsletter: 'Top 10 Opportunities'
		}
	}
}
</script>
